import { render, staticRenderFns } from "./ClientLogin.vue?vue&type=template&id=072160b8"
import script from "./ClientLogin.vue?vue&type=script&lang=js"
export * from "./ClientLogin.vue?vue&type=script&lang=js"
import style0 from "./ClientLogin.vue?vue&type=style&index=0&id=072160b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports